var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-permissions-tab" }, [
    _c(
      "div",
      { staticClass: "search-section" },
      [
        _c("a-input-search", {
          staticClass: "search-input",
          attrs: { placeholder: _vm.$t("message.search") },
          on: { search: _vm.onSearch },
          model: {
            value: _vm.searchText,
            callback: function ($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "scopes-table" }, [
      _c(
        "div",
        { staticClass: "scopes-table-header" },
        [
          _c("div", { staticClass: "header-cell target-header" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("tables.permissions.targetHeader")) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.scopeGroups, function (group) {
            return _c("div", { key: group.id, staticClass: "header-group" }, [
              _c("div", { staticClass: "group-title" }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v(_vm._s(group.icon)),
                ]),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t(group.titleKey)) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "group-scopes" },
                _vm._l(group.scopes, function (scope) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: { content: _vm.getScopeDescription(scope) },
                          expression: "{ content: getScopeDescription(scope) }",
                        },
                      ],
                      key: scope,
                      staticClass: "scope-header",
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.getScopeLabelText(scope)) +
                          "\n                    "
                      ),
                    ]
                  )
                }),
                0
              ),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "scopes-table-body" }, [
        _vm.filteredActiveUsers.length > 0
          ? _c(
              "div",
              { staticClass: "group-section" },
              [
                _c("div", { staticClass: "group-header active-group" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("check_circle"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "Yetkili Kullanıcılar (" +
                        _vm._s(_vm.filteredActiveUsers.length) +
                        ")"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.filteredActiveUsers, function (userItem, index) {
                  return _c("UserPermissionRow", {
                    key: "active-user-" + userItem.user._id,
                    attrs: {
                      user: userItem.user,
                      target: userItem.target,
                      "target-index": userItem.targetIndex,
                      "scope-groups": _vm.scopeGroups,
                      "permission-targets": _vm.permissionTargets,
                      departments: _vm.departments,
                      "current-user-id": _vm.currentUserId,
                      "is-active": true,
                      "is-odd": index % 2 === 1,
                    },
                    on: {
                      "toggle-scope": _vm.onToggleScope,
                      deactivate: _vm.onDeactivate,
                    },
                  })
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.filteredInactiveUsers.length > 0
          ? _c(
              "div",
              { staticClass: "group-section" },
              [
                _c("div", { staticClass: "group-header inactive-group" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("radio_button_unchecked"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "Diğer Kullanıcılar (" +
                        _vm._s(_vm.filteredInactiveUsers.length) +
                        ")"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.filteredInactiveUsers, function (user, index) {
                  return _c("UserPermissionRow", {
                    key: "inactive-user-" + user._id,
                    attrs: {
                      user: user,
                      target: null,
                      "target-index": -1,
                      "scope-groups": _vm.scopeGroups,
                      "permission-targets": _vm.permissionTargets,
                      departments: _vm.departments,
                      "current-user-id": _vm.currentUserId,
                      "is-active": false,
                      "is-odd": index % 2 === 1,
                    },
                    on: { activate: _vm.onActivate },
                  })
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }